/**
 * RAFAELS EIGENE NAVIGATION GEWINNT GEGEN AELTERE HINTERGRUNDAUFTRAEGE (26.10.2026).
 *
 * Rafael, 26.10.2026 08:38Z nach zwei Wechseln Ruckelshausen → Mühl: ein späterer bewusster
 * Navigationsschritt von ihm darf nie von einem älteren Hintergrundauftrag überschrieben werden.
 * Befund: local-storage/cui-buehnenwechsel-20261026/ERGEBNIS.md. Er hatte Ruckelshausen 15 s
 * vor dem zweiten Öffnungsauftrag selbst geöffnet; `handWahl` im GuidePanel zählt jede Öffnung,
 * auch die der Aufträge, und schützt nur während eines laufenden Abrufs.
 *
 * Dieser Stand zählt NUR Rafaels eigene Schritte (Bühne anklicken, vor/zurück, schließen).
 * Er ist je Fenster (Modul), damit die Fensterabfrage in App.tsx ihn mitmelden kann
 * (`handNav`) und der Server ihn an den Öffnungsauftrag hängt: der Client sieht dann, ob
 * Rafael seit Auftragserteilung selbst navigiert hat.
 */

/** Nach Rafaels eigener Wahl wird seine Bühne so lange nicht ersetzt, sondern nur angeboten. */
export const RAFAEL_SCHONFRIST_MS = 60_000;

let stand = { n: 0, am: 0 };

export function rafaelNavigiert(jetzt = Date.now()): void {
  stand = { n: stand.n + 1, am: jetzt };
}

export function rafaelNavStand(): { n: number; am: number } {
  return stand;
}

/**
 * Was mit einem Öffnungsauftrag geschieht:
 *  - `verwerfen`: Rafael hat seit Auftragserteilung (`handNav` am Auftrag) selbst navigiert.
 *  - `anbieten`: er hat binnen der Schonfrist selbst eine andere Bühne gewählt, die noch offen ist.
 *  - `durch`: nichts davon — der Auftrag darf öffnen.
 */
export function auftragGegenRafael(handNavAmAuftrag: number, offenId: string | null, zielId: string,
  jetzt = Date.now(), s = stand): 'durch' | 'verwerfen' | 'anbieten' {
  if (s.n !== handNavAmAuftrag) return 'verwerfen';
  // Schnellbühnen (sb-*) entstehen aus Rafaels eigener Zwischenfrage und öffnen im Fenster ihrer
  // Bezugsbühne (server/routes/schnellchat.ts) — sie werden wie bisher nicht zum Angebot.
  if (offenId && offenId !== zielId && !zielId.startsWith('sb-') && s.am > 0 && jetzt - s.am < RAFAEL_SCHONFRIST_MS) return 'anbieten';
  return 'durch';
}
